import { render, staticRenderFns } from "./BAVideoPlayer.vue?vue&type=template&id=24268e47&scoped=true&"
import script from "./BAVideoPlayer.vue?vue&type=script&lang=ts&"
export * from "./BAVideoPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./BAVideoPlayer.vue?vue&type=style&index=0&id=24268e47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24268e47",
  null
  
)

export default component.exports